// Agrupación de sujetos procesales para mostrarlos de forma legible.
//
// La Rama Judicial publica los involucrados como una sola cadena con el
// formato "Rol: Nombre | Rol: Nombre | …". Agrupar por rol evita repetir la
// etiqueta en cada nombre y permite mostrarlos como fichas.

export type GrupoInvolucrados = {
  /** Rol tal como lo publica la fuente; vacío si el registro no trae rol. */
  rol: string;
  nombres: string[];
};

/**
 * Convierte la cadena de sujetos procesales en grupos por rol.
 *
 * Conserva el orden de primera aparición de cada rol y el de los nombres.
 * Los registros sin rol quedan en un grupo sin etiqueta. Entradas vacías o
 * sin nombre se descartan.
 */
export function agruparSujetosProcesales(texto: string): GrupoInvolucrados[] {
  const grupos: GrupoInvolucrados[] = [];
  const posiciones = new Map<string, number>();

  for (const parte of String(texto ?? '').split('|')) {
    const limpio = parte.trim();
    if (!limpio) continue;

    const separador = limpio.indexOf(':');
    const rol = separador >= 0 ? limpio.slice(0, separador).trim() : '';
    const nombre = (separador >= 0 ? limpio.slice(separador + 1) : limpio).trim();
    if (!nombre) continue;

    const posicion = posiciones.get(rol);
    if (posicion === undefined) {
      posiciones.set(rol, grupos.length);
      grupos.push({ rol, nombres: [nombre] });
    } else {
      grupos[posicion].nombres.push(nombre);
    }
  }

  return grupos;
}
